import type { Ref } from 'vue';
import { ref } from 'vue';

export interface IMerchantLogoPreviewComposable {
  merchantLogoUrl: Ref<string | undefined>;
  merchantName: Ref<string | undefined>;
  onPreview(logoUrl?: string, name?: string): void;
  onPreviewHide(): void;
}

export default function useMerchantLogoPreview(): IMerchantLogoPreviewComposable {
  const merchantLogoUrl = ref<string | undefined>();
  const merchantName = ref<string | undefined>();

  function onPreview(logoUrl?: string, name?: string): void {
    merchantLogoUrl.value = logoUrl;
    merchantName.value = name;
  }

  function onPreviewHide(): void {
    merchantLogoUrl.value = undefined;
    merchantName.value = undefined;
  }

  return {
    merchantLogoUrl,
    merchantName,
    onPreview,
    onPreviewHide,
  };
}
